interface Props {
  role: string;
}

const ROLE_CONFIG: Record<string, { label: string; color: string }> = {
  driver: { label: 'Conductor', color: 'bg-blue-600' },
  fleet_manager: { label: 'Fleet Manager', color: 'bg-emerald-600' },
  customer: { label: 'Cliente', color: 'bg-purple-600' },
};

export function RoleBadge({ role }: Props) {
  const config = ROLE_CONFIG[role] ?? { label: role, color: 'bg-gray-600' };
  return (
    <span className={`${config.color} text-white text-xs font-medium px-2 py-0.5 rounded-full`}>
      {config.label}
    </span>
  );
}
